"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CollectionSingleColorIcon24 = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const CollectionSingleColorIcon24 = _ref => {
  let {
    color,
    backgroundColor,
    ...rest
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24"
  }, rest), /*#__PURE__*/_react.default.createElement("path", {
    fill: backgroundColor,
    d: "M3 7v10a4 4 0 0 0 4 4h10c2.21 0 4-1.789 4-3.998V6.996C21 4.787 19.21 3 17 3H7a4 4 0 0 0-4 4"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: backgroundColor,
    d: "M15.173 3.7H8.85v11.205a.5.5 0 0 0 .828.378L11.7 13.53a.5.5 0 0 1 .657.002l1.986 1.74a.5.5 0 0 0 .83-.375z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M4.4 7v10A2.6 2.6 0 0 0 7 19.6h10c1.437 0 2.6-1.163 2.6-2.598V6.996A2.597 2.597 0 0 0 17 4.4H7A2.6 2.6 0 0 0 4.4 7M3 17V7a4 4 0 0 1 4-4h10c2.21 0 4 1.787 4 3.996v10.006C21 19.212 19.21 21 17 21H7a4 4 0 0 1-4-4",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M8.15 3.7a.7.7 0 0 1 .7-.7h6.323a.7.7 0 0 1 .7.7v11.197c0 1.031-1.216 1.582-1.991.902l-1.856-1.626-1.89 1.639c-.777.673-1.986.121-1.986-.907zm1.4.7v10.067L11.241 13a1.2 1.2 0 0 1 1.577.005l1.655 1.45V4.4zm-.331 10.354",
    clipRule: "evenodd"
  }));
};
exports.CollectionSingleColorIcon24 = CollectionSingleColorIcon24;
//# sourceMappingURL=CollectionSingleColorIcon24.js.map